export default __webpack_public_path__ + "static/media/instant-premium-message.e798adae.png";